module.exports = __webpack_public_path__ + "img/university-app-home.b09c2b98.png";